<template>
  <div class="right-panel">
    <dv-border-box-12 class="panel-box compare-section">
      <div class="panel-inner">
        <div class="section-title">
          <dv-decoration-6 style="width:200px;height:20px;" />
          <span class="title-text">平台对比分析</span>
        </div>
        <PlatformCompare />
      </div>
    </dv-border-box-12>
    <dv-border-box-12 class="panel-box rank-section">
      <div class="panel-inner">
        <div class="section-title">
          <dv-decoration-6 style="width:200px;height:20px;" />
          <span class="title-text">SKU销售排行榜</span>
        </div>
        <SkuRanking />
      </div>
    </dv-border-box-12>
    <dv-border-box-12 class="panel-box dynamic-section">
      <div class="panel-inner">
        <div class="section-title">
          <dv-decoration-6 style="width:200px;height:20px;" />
          <span class="title-text">实时销售动态</span>
        </div>
        <RealtimeDynamic />
      </div>
    </dv-border-box-12>
  </div>
</template>

<script>
import PlatformCompare from './PlatformCompare.vue'
import SkuRanking from './SkuRanking.vue'
import RealtimeDynamic from './RealtimeDynamic.vue'

export default {
  name: 'RightPanel',
  components: { PlatformCompare, SkuRanking, RealtimeDynamic }
}
</script>

<style scoped>
.right-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.panel-box {
  min-height: 260px;
}

.panel-inner {
  padding: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.title-text {
  font-size: 15px;
  font-weight: bold;
  color: #00D4FF;
  white-space: nowrap;
}
</style>
